import React from 'react';
import { useIntl } from 'react-intl';

const Loading = () => {
  const intl = useIntl();
  return (
    <div className="flex justify-center items-center p-8">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      <span className="ml-3 text-gray-600">{intl.formatMessage({ id: 'succession.cash_flow_analysis.loading.loading' })}</span>
    </div>
  );
};

export default Loading; 